import { useTranslation } from "react-i18next";
import { usePageMeta } from "@/hooks/usePageMeta";
import styles from "./ContentPage.module.css";

export function Privacy() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.startsWith("de") ? "de" : "non-de";

  usePageMeta({
    title: t("pageMeta.privacyTitle"),
    description: t("pageMeta.privacyDescription"),
  });

  return (
    <article className={styles.page}>
      <div>
        <h1>{t("privacy.title")}</h1>
        {lang === "non-de" && (
          <p className={styles.disclaimer}>{t("privacy.legalDisclaimer")}</p>
        )}
      </div>

      <section>
        <h2>Verantwortlicher</h2>
        <p>
          brings-mit.com, Joachim Klingler, Holunderweg 5, 73479 Ellwangen,
          E-Mail: <a href="mailto:hello@brings-mit.com">hello@brings-mit.com</a>.
        </p>
      </section>

      <section>
        <h2>Was wir speichern — und was nicht</h2>
        <ul>
          <li>
            <strong>Kein Benutzerkonto.</strong> Wir verwalten weder Passwörter
            noch Profile. Zugang zu einer Veranstaltung erfolgt allein über die
            URL mit dem zufällig erzeugten Schlüssel.
          </li>
          <li>
            <strong>Kein Tracking.</strong> Keine Cookies außer den technisch
            notwendigen, keine Analyse-Tools, kein Reporting an Dritte.
          </li>
          <li>
            <strong>Hosting in Deutschland.</strong> Anwendung und Datenbank
            laufen auf einer Hetzner-VM in einem deutschen Rechenzentrum.
          </li>
        </ul>
      </section>

      <section>
        <h2>Verarbeitete Daten</h2>
        <ul>
          <li>
            <strong>Veranstaltungsdaten:</strong> Titel, Datum, Ort, Deadline,
            Beschreibung, optional Name und E-Mail der Erstellerin/des
            Erstellers. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO
            (Vertragserfüllung).
          </li>
          <li>
            <strong>Teilnehmerdaten:</strong> Name, Anzahl Personen, RSVP-Status.
            Übermittelt durch den jeweiligen Teilnehmer oder den Admin.
          </li>
          <li>
            <strong>Log-Daten:</strong> temporäre Rate-Limit-Einträge mit IP und
            Zeitstempel für Missbrauchsschutz (Löschung nach 24h).
          </li>
          <li>
            <strong>Zahlungsdaten (nur bei PRO-Upgrade):</strong> Die Zahlung
            läuft ausschließlich über Stripe (Stripe Payments Europe, Ltd.).
            Wir speichern nur die Stripe-Session-ID und den Zeitpunkt der
            Aktivierung — keine Kartendaten.
          </li>
        </ul>
      </section>

      <section>
        <h2>Speicherdauer und Löschung</h2>
        <ul>
          <li>
            <strong>7 Tage nach dem Veranstaltungsdatum</strong> werden die
            E-Mail-Adressen und zugehörigen Benachrichtigungs-Flags automatisch
            gelöscht.
          </li>
          <li>
            <strong>30 Tage nach dem Veranstaltungsdatum</strong> wird die
            Veranstaltung inklusive aller Teilnehmer- und Mitbringsel-Daten
            vollständig und unwiderruflich gelöscht.
          </li>
          <li>
            Vorher kann der Admin die Veranstaltung jederzeit absagen oder
            löschen.
          </li>
        </ul>
      </section>

      <section>
        <h2>Ihre Rechte</h2>
        <p>
          Sie haben nach der DSGVO das Recht auf Auskunft, Berichtigung,
          Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und
          Widerspruch. Schicken Sie dafür eine E-Mail an
          <a href="mailto:hello@brings-mit.com"> hello@brings-mit.com</a>.
          Beschwerden können an die zuständige Aufsichtsbehörde gerichtet werden.
        </p>
      </section>

      <section>
        <h2>Cookies</h2>
        <p>
          Wir setzen keine nicht-essenziellen Cookies. Die Sprachwahl wird in
          <code> localStorage</code> gespeichert (keine personenbezogenen Daten).
        </p>
      </section>
    </article>
  );
}
